import React from 'react';
import Fade from 'react-reveal/Fade';

import { HeroContainer, HeroHeader } from './hero.styles';

const HomePage = () => (
	<Fade left>
		<HeroContainer>
			<HeroHeader>
				Hello, my name is <br />
				<span style={{ color: '#ef4565' }}>Trevor Marlowe.</span>
				<br />
				Software Developer.
			</HeroHeader>
		</HeroContainer>
	</Fade>
);

export default HomePage;
